import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class RegExUtility {

  public static isIncludesOnlyDigits(value: string) {
    return /^\d+$/.test(value);
  }
}
